// extracted by mini-css-extract-plugin
export default {"container":"Feeds_container__Q4hgR","feed":"Feeds_feed__Mq613","body":"Feeds_body__6s4rG"};